import React from "react";
import { Typography, Box } from "@material-ui/core";
import { getLang } from "app/feature/constants";
import {
  ASSIGN_BATCH_STATUS_FAIL,
  ASSIGN_BATCH_STATUS_SUCCESS,
} from "modules/serial-number/constants";

export default function AssignStatusProgressComponent({
  lang,
  progress,
  status,
}) {
  return (
    <Box>
      <Typography
        variant="caption"
        style={{
          color:
            status === ASSIGN_BATCH_STATUS_FAIL
              ? "#FDB022"
              : status === ASSIGN_BATCH_STATUS_SUCCESS
              ? "#32D583"
              : "#989898",
          textTransform: "capitalize",
        }}
      >
        {status === ASSIGN_BATCH_STATUS_FAIL
          ? getLang(lang, "label.WARNING")
          : status === ASSIGN_BATCH_STATUS_SUCCESS
          ? getLang(lang, "label.SUCCESS")
          : `${progress}%`}
      </Typography>
    </Box>
  );
}
